import api from './index';
import { axios } from '@/utils/request';

export function getCommonInfo(data) {
    return axios({
        url: api.COMMON_INFO,
        method: 'POST',
        data
    })
}